import { render, staticRenderFns } from "./CotacaoFrete.vue?vue&type=template&id=54fb2a4b&"
import script from "./CotacaoFrete.vue?vue&type=script&lang=js&"
export * from "./CotacaoFrete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports